<template>
  <div class="main">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <h2>培训详情</h2>
    <ul class="grey">
      <li :class="state == 0 ? 'blue' : ''" @click="switchInfo(0)">培训信息</li>
      <li :class="state == 1 ? 'blue' : ''" @click="switchInfo(1)">
        学员学习情况
      </li>
    </ul>
    <div class="main_body" v-if="state == 0">
      <div class="title_view">
        <p>培训名称：</p>
        <p>{{ trainInfo.Name }}</p>
      </div>
      <div class="title_view">
        <p>培训时间：</p>
        <p>
          {{ trainInfo.begainTime + " - " + trainInfo.endTime }}
          <span>{{ trainInfo.days }}天</span>
        </p>
      </div>
      <div class="title_view">
        <p>备注：</p>
        <p>{{ trainInfo.Remark }}</p>
      </div>
      <p class="arrange">任务安排：</p>
      <div class="table_view">
        <el-table :data="getDatalist" height="540" border style="width: 80%">
          <el-table-column prop="itemName" label="任务名" width="180">
          </el-table-column>
          <el-table-column prop="typeLabel" label="类型" width="180">
          </el-table-column>
          <el-table-column prop="priorityLable" label="优先级">
          </el-table-column>
          <el-table-column prop="score" label="学分"> </el-table-column>
          <el-table-column prop="BeginTime1" width="180" label="进行时间">
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作"
            align="center"
            width="406"
          >
            <template slot-scope="scope">
              <div class="operation_box">
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.type === 'exam'"
                  @click="toTypePage(0, scope.row)"
                  >批改</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.type === 'exam'"
                  @click.stop="releaseBtn(scope.row)"
                  >发布</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-if="scope.row.type === 'exam'"
                  @click.stop="exportDetails(scope.row)"
                  >导出答题详情</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="toTypePage(1, scope.row)"
                  v-if="scope.row.type === 'exam'"
                  >补考</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="toTypePage(2, scope.row)"
                  v-if="scope.row.type === 'exam'"
                  >成绩报告</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-else-if="scope.row.type === 'exercise'"
                  @click="practiceClick(scope.row)"
                  >练习查询</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  v-else
                  @click="toStudyInfo(scope.row)"
                  >学习情况</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="situation_view" v-else>
      <h2>已完成培训人数：{{ completeNum }}</h2>
      <div class="examin_head">
        <el-form
          :label-position="labelPosition"
          label-width="80px"
          :model="formLabelAlign"
          ref="formLabelAlign"
        >
          <el-form-item label="姓名：" prop="name">
            <el-input
              v-model.trim="formLabelAlign.name"
              placeholder="请输入姓名："
            ></el-input>
          </el-form-item>
          <el-form-item label="科室：" prop="department">
            <el-select
              v-model="formLabelAlign.department"
              clearable
              filterable
              multiple
              collapse-tags
              placeholder="全部"
              @change="searchChang()"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in keshioptions"
                :key="item.DepartmentID"
                :label="item.DepartmentName"
                :value="item.DepartmentID"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职位：" prop="position">
            <el-select
              v-model="formLabelAlign.position"
              placeholder="全部"
              multiple
              collapse-tags
              @change="searchChang()"
            >
              <el-option label="全部" value=""></el-option>
              <el-option
                v-for="item in zhiweioptions"
                :key="item.PTitle"
                :label="item.PTitle"
                :value="item.PTitle"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <div class="query_btn">
            <el-button
              type="primary"
              icon="el-icon-search"
              class="searchbtn"
              @click="searchBtn"
              >搜索</el-button
            >
            <el-button
              icon="el-icon-refresh"
              class="searchbtn sonbtn"
              @click="resetForm('formLabelAlign')"
              >重置</el-button
            >
            <el-button icon="el-icon-refresh" @click="exportExecl"
              >导出execl</el-button
            >
          </div>
        </el-form>
      </div>
      <div class="situation_table" v-loading="loading">
        <el-table
          :data="Datalist"
          border
          ref="multipleTable"
          style="width: 100%"
        >
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="address"
            label="学习记录"
            align="center"
            width="120"
          >
            <template slot-scope="scope">
              <div class="operation_box">
                <el-button type="text" size="small" @click="toView(scope.row)"
                  >查看</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
      </div>
      <div class="foot_box">
        <div class="foot_pagetions">
          <p>共有{{ total }}条记录，当前第{{ currentPage }}/{{ pagesun }}页</p>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="showpageindex"
            :page-size="pageSize"
            :page-sizes="pagesizesarr"
            layout="prev, pager, next,sizes, jumper"
            :total="total"
            class="pagination"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 发布试卷弹窗 -->
    <div class="everywhere">
      <el-dialog
        title="发布提示"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="delete_mian">
          <!-- <i class="iconfont icon-tishi1"></i> -->
          <div class="mode_view">
            <el-radio-group v-model="achievement">
              <el-radio :label="0">仅发布成绩</el-radio>
              <el-radio :label="1">发布成绩和答题详情</el-radio>
            </el-radio-group>
          </div>
          <p class="p">成绩一经发布将不得修改，确定发布吗？</p>
        </div>
        <p></p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="sundflag" @click="deteRelease">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 导出成绩 -->
    <div class="exportView">
      <el-dialog
        title="温馨提示"
        :visible.sync="exportVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="delete_mian">
          <p>
            导出成绩前请留意主观题是否完成批阅且发布成绩，成绩未发布的考试无法导出答题详情。后台需要几分钟来生成您需要的试卷文件，点击确认开始生成试卷文件。
          </p>
        </div>
        <p></p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="exportVisible = false">取 消</el-button>
          <el-button type="primary" @click="exportTow()" :loading="sundflag">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import loginvuex from "@/store/index";
import training from "@/api/trainingApi";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { oneKeyPublishResult, exportAnswer } from "@/api/index.js";
import { getSectionList, getPTitleList } from "@/services/examManager.js";
export default {
  data() {
    return {
      state: 0,
      trainInfo: "",
      getDatalist: [],
      completeNum: 0,
      State: true, // false为导出答题详情弹窗确定按钮
      exportVisible: false, // 导出成绩提示弹窗
      labelPosition: "right",
      dialogVisible: false, // 发布成绩弹窗
      formLabelAlign: {
        name: "", //考生姓名
        department: "", //科室
        position: "", //职位
      },
      zhiweioptions: [], // 职位
      keshioptions: [],
      getDataCondition: {
        name: "", //考生姓名
      },
      loading: false,
      Datalist: [],
      showpageindex: 1, //显示的索引盒子
      currentPage: 1, //  当前页数
      pageSize: 10, //每页的条数
      pagesizesarr: [5, 10, 20, 50, 100],
      pagesun: "", //一共多少页
      total: 100,
      sundflag: false, // 发布试卷的防抖
      achievement: 1, // 发布成绩模式
      formColumns: [
        {
          prop: "RealName",
          label: "学员名称",
        },
        {
          prop: "DepartmentName",
          label: "科室",
        },
        {
          prop: "PTitle",
          label: "职位",
        },
        {
          prop: "situation",
          label: "培训情况",
        },
        {
          prop: "doneCount",
          label: "已完成任务",
        },
        {
          prop: "getScore",
          label: "已获得学分",
        },
        {
          prop: "exerciseScore",
          label: "练习学分",
        },
        {
          prop: "examScore",
          label: "考试学分",
        },
        {
          prop: "courseScore",
          label: "课件学分",
        },
        {
          prop: "videoScore",
          label: "培训情况",
        },
      ],
    };
  },
  props: ["cutcoms"],
  methods: {
    // 返回按键
    backBtn() {
      sessionStorage.removeItem("examRow");
      if (this.$route.query.trainId) {
        this.$router.push({
          path: this.$route.query.toUrl,
        });
      }
      this.$destroy();
      this.cutcoms(0);
    },
    // 跳转批改试卷
    toTypePage(type, row) {
      // type 0批改 1补考 2成绩报告
      if (type == 1) {
        localStorage.setItem(
          "examRowTime",
          JSON.stringify(this.$parent.examRow)
        );
      }
      this.$router.push({
        path: "correcting",
        query: {
          trainId: row.trainId,
          typeId: row.typeId,
          type: type,
          examType: row.type,
          typeState: row.type,
          scoreId: row.scoreId,
          toUrl: this.$parent.type == 0 ? "manage" : "situation",
        },
      });
    },
    // 跳转练习查询
    practiceClick(row) {
      this.$router.push({
        path: "practiceWatch",
        query: {
          trainId: row.trainId,
          typeId: row.typeId,
          examType: row.type,
          scoreId: row.scoreId,
          toUrl: this.$parent.type == 0 ? "manage" : "situation",
        },
      });
    },
    // 跳转学习情况
    toStudyInfo(row) {
      console.log(row);
      if (row.type === "courseware") {
        // 去课件
        this.$router.push({
          path: "resources",
          query: {
            state: "xxqk",
            trainId: row.trainId,
            typeId: row.typeId,
            type: row.type,
            scoreId: row.scoreId,
            toUrl: this.$parent.type == 0 ? "manage" : "situation",
          },
        });
      } else {
        // 视频
        this.$router.push({
          path: "videoresources",
          query: {
            state: "xxqk",
            trainId: row.trainId,
            typeId: row.typeId,
            type: row.type,
            scoreId: row.scoreId,
            toUrl: this.$parent.type == 0 ? "manage" : "situation",
          },
        });
      }
    },
    // 查看
    toView(row) {
      this.$parent.rowInfo = row;
      console.log(this.$parent.type);
      if (this.$parent.type == 0) {
        this.cutcoms(7);
      } else {
        this.cutcoms(2);
      }
    },
    async deteRelease() {
      this.sundflag = true;
      let params = {
        examID: this.$parent.examInfo.ExamID,
        isAnswerDetail: this.achievement, // 0:只发布成绩，1:成绩+答题详情
      };
      const Data = await oneKeyPublishResult(params);
      if (Data.data.Status === 200) {
        this.dialogVisible = false;
        this.$message({
          message: "恭喜你，发布成功",
          type: "success",
        });
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        this.getDetailsTrainin();
      } else {
        this.$message.error(Data.data.Data);
        this.sundflag = false;
      }
    },
    // 发布成绩
    releaseBtn(row) {
      this.dialogVisible = true;
      const obj = {
        scoreId: row.scoreId,
        type: row.type,
        typeId: row.typeId,
      };
      this.getTypeDetail(obj);
      console.log(row);
    },
    // 导出答题详情确定导出
    async exportTow() {
      this.sundflag = true;
      let parmas = {
        examID: this.$parent.examInfo.ExamID,
        isAnswer: 1,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await exportAnswer(parmas);
      if (Data.status == 200) {
        setTimeout(() => {
          this.State = false; // 弹窗false为导出答题详情确定按钮
          this.exportVisible = true;
          const blob = new Blob([Data.data]);
          let link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute(
            "download",
            `${this.$parent.examInfo.ExamName}.zip`
          );
          link.click();
          link = null;
          this.sundflag = false;
          this.State = true;
          this.exportVisible = false;
        }, 500);
      } else if (Data.status == 202) {
        if (!Data.headers["content-disposition"]) {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([Data.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            if (fileReader.result) {
              const msg = JSON.parse(fileReader.result);
              if (msg.status == 202) {
                this.$alert(msg.data, "温馨提示", {
                  confirmButtonText: "了解",
                  type: "warning",
                }).then(() => {
                  setTimeout(() => {
                    this.sundflag = false;
                    this.exportVisible = false;
                  }, 500);
                });
              }
            }
          };
        }
      } else {
        this.$message.error(
          "当前文件过大，后台正在生成文件，请5分钟之后再来下载"
        );
        this.sundflag = false;
        this.State = true;
        this.exportVisible = false;
      }
    },
    // 导出答题详情 ===> 获取ID请求
    async exportDetails(row) {
      const obj = {
        scoreId: row.scoreId,
        type: row.type,
        typeId: row.typeId,
      };
      this.getTypeDetail(obj);
      console.log(this.$parent.examInfo, "mmms");
      this.State = false; // 弹窗false为导出答题详情确定按钮
      this.exportVisible = true;
      return;
    },
    async getTypeDetail(obj) {
      const { data } = await training.getTypeDetail(obj);
      if (data.Status == 200) {
        this.$parent.examInfo = data.Data;
      } else {
        this.$message.error(data.Data);
      }
    },
    async getDetailsTrainin() {
      const obj = {
        trainId: this.$parent.examRow.tranid,
      };
      const { data } = await training.getTrainByID(obj);
      if (data.Status == 200) {
        this.trainInfo = data.Data.trainInfo;
        this.trainInfo.begainTime = this.$moment(
          this.trainInfo.begainTime
        ).format("YYYY-MM-DD");
        this.trainInfo.endTime = this.$moment(this.trainInfo.endTime).format(
          "YYYY-MM-DD"
        );
        let newarr = data.Data.trainContent.courseArr.concat(
          data.Data.trainContent.examArr,
          data.Data.trainContent.excerciseArr,
          data.Data.trainContent.videoArr
        );
        newarr = newarr.map((item) => {
          if (item.itemBeginTime && item.itemEndTime) {
            item.BeginTime1 =
              this.$moment(item.itemBeginTime).format("YYYY-MM-DD") +
              "-" +
              this.$moment(item.itemEndTime).format("YYYY-MM-DD");
          } else {
            item.BeginTime1 = "暂无";
          }
          if (item.Priority == 1) {
            item.priorityLable = "优先级高";
          } else if (item.Priority == 2) {
            item.priorityLable = "优先级中";
          } else if (item.Priority == 3) {
            item.priorityLable = "优先级低";
          } else if (item.Priority == 99) {
            item.priorityLable = "空";
          }
          if (item.type === "exam") {
            item.typeLabel = "考试";
          } else if (item.type === "exercise") {
            item.typeLabel = "练习";
          } else if (item.type === "courseware") {
            item.typeLabel = "课件";
          } else if (item.type === "video") {
            item.typeLabel = "视频";
          }
          item.time = new Date(item.itemBeginTime).getTime();
          return item;
        });
        this.getDatalist = newarr.sort((a, b) => a.time - b.time);

        console.log(this.getDatalist, "???");
      } else {
        this.$message.error(data.Data);
      }
    },
    switchInfo(type) {
      if (type == 0) {
        this.getDetailsTrainin();
      } else {
        this.getStudySituation();
      }
      this.state = type;
    },
    // 获取科室数据
    async getSectionData() {
      const sectionObj = {};
      const { data } = await getSectionList(sectionObj);
      if (data.Status === 200) {
        // console.log(data, "科室下拉列表数据");
        this.keshioptions = data.Data;
      }
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.loading = true;
      this.getStudySituation(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.loading = true;
      this.getStudySituation();
    },
    // 获取职称数据
    async getPTitleData() {
      const sectionObj = {};
      const { data } = await getPTitleList(sectionObj);
      if (data.Status === 200) {
        this.zhiweioptions = data.Data.map((element, index) => {
          element.pTitleID = index;
          return element;
        });
      }
    },
    // 搜索
    searchBtn() {
      this.currentPage = 1;
      this.loading = true;
      if (this.formLabelAlign.name) {
        this.getDataCondition.name = this.formLabelAlign.name;
      } else {
        this.getDataCondition.name = "";
      }
      this.getStudySituation();
    },
    // 导出
    exportExecl() {
      this.loading = true;
      this.$confirm("此操作将下载学员学习情况, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let newarr = this.Datalist.map((item, index) => {
            const obj = {
              序号: index + 1,
              学员名称: item.RealName,
              科室: item.DepartmentName,
              职位: item.Position,
              培训情况: item.situation,
              已完成任务: item.doneCount,
              已获得学分: item.getScore,
              练习学分: item.exerciseScore,
              考试学分: item.examScore,
              课件学分: item.courseScore,
              培训情况: item.videoScore,
            };
            return obj;
          });
          const worksheet = XLSX.utils.json_to_sheet(newarr);
          // 创建一个新的工作簿
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          // 生成Excel文件的二进制数据
          const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });
          // 将二进制数据转换为Blob对象
          const blob = new Blob([excelBuffer], {
            type: "application/octet-stream",
          });
          // 使用file-saver保存文件
          saveAs(blob, "学员学习情况.xlsx");
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "已取消",
            });
          }, 500);
        });
    },
    // 重置
    resetForm(formLabelAlign) {
      this.loading = true;
      this.currentPage = 1;
      this.getDataCondition.name = "";
      this.$refs[formLabelAlign].resetFields();
      this.getStudySituation();
    },
    // 获取培训学员学习情况
    async getStudySituation() {
      this.loading = true;
      const obj = {
        trainId: this.$parent.examRow.tranid,
        stuName: this.getDataCondition.name,
        departmentIDArr: [],
        pTitle: "",
        pageNum: this.currentPage - 1,
        pageSize: this.pageSize,
      };
      if (this.formLabelAlign.position[0]) {
        obj.pTitle = JSON.stringify(this.formLabelAlign.position);
      }
      if (this.formLabelAlign.department[0]) {
        obj.departmentIDArr = JSON.stringify(this.formLabelAlign.department);
      }
      const { data } = await training.getStudyList(obj);
      if (data.Status == 200) {
        this.Datalist = data.Data.list.map((item) => {
          if (item.getScore >= item.PassScore) {
            item.situation = "已完成";
          } else {
            item.situation = "未完成";
          }
          for (let ztiem in item) {
            if (
              item[ztiem] === "" ||
              item[ztiem] === null ||
              item[ztiem] === undefined
            ) {
              item[ztiem] = "未设置";
            }
          }
          return item;
        });
        console.log(data, "this.Datalist0", this.Datalist);

        this.total = data.Data.total;
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } else {
        this.$message.error(data.Data);
      }
      console.log(data);
    },
    // chang搜索
    searchChang() {
      this.currentPage = 1;
      this.loading = true;
      this.getStudySituation();
    },
  },
  activated() {
    this.getDetailsTrainin();
    this.getSectionData();
    this.getPTitleData();
  },
};
</script>

<style lang="scss" scoped>
.main {
  box-sizing: border-box;
  background-color: #ffffff;
  width: 100%;
  min-height: 780px;
}
h2 {
  padding: 24px;
  margin-bottom: 48px;
}
// 返回按键css
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.grey {
  list-style-type: none;
  padding: 24px;
  display: flex;
  text-align: center;
  line-height: 40px;
  li {
    width: 120px;
    height: 40px;
    background: #f2f2f2;
  }
}
.blue {
  background: #0052d9 !important;
  color: #fff;
  font-weight: bold;
}
.main_body {
  padding: 24px;
  .title_view {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    > p {
      &:nth-child(1) {
        font-size: 20px;
      }
      &:nth-child(2) {
        font-size: 18px;
        margin-left: 24px;
        > span {
          margin-left: 34px;
        }
      }
    }
  }
  .arrange {
    margin: 34px 0px 24px 0px;
    font-size: 20px;
  }
}
::v-deep .cell {
  text-align: center;
}
.el-button--text {
  font-size: 16px;
}
.examin_head {
  padding: 30px 24px 10px 10px;
  display: flex;
  flex-wrap: wrap;
  .el-form {
    display: flex;
    flex-wrap: wrap;
    ::v-deep .el-input__inner {
      width: 160px;
    }
  }
  ::v-deep .el-form-item {
    &:nth-child(7) {
      .el-form-item__label {
        width: 140px !important;
      }
      .el-form-item__content {
        margin-left: 140px !important;
      }
      .el-input__inner {
        width: 360px !important;
      }
      .el-range-separator {
        padding: 0;
      }
    }
  }
  .query_btn {
    display: flex;
    .el-button {
      width: 88px;
      height: 40px;
      margin-left: 24px;
      &:nth-child(3) {
        background: #409eff;
        color: #fff;
        width: 120px;
      }
    }
  }
}
// 分页
.foot_box {
  position: relative;
  height: 86px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
.situation_table {
  padding: 0px 20px 0px 34px;
  p {
    margin-bottom: 16px;
  }
}
.everywhere {
  ::v-deep .el-dialog {
    width: 441px !important;
    min-height: 188px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .delete_mian {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .el-radio-group {
      display: flex;
    }
    ::v-deep .el-radio__label {
      font-size: 16px;
    }
    i {
      display: inline-block;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: center;
      font-size: 14px !important;
      color: #ababab;
      margin-top: 12px;
    }
  }
}
.exportView {
  ::v-deep .el-dialog {
    width: 340px !important;
    min-height: 220px !important;
    line-height: 24px;
    border-radius: 5px 5px 0px 0px;
  }
}
::v-deep.el-dialog__header {
  padding: 16px 20px 10px;
}
::v-deep .el-dialog__header {
  height: 55px;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  background: linear-gradient(
    180deg,
    #64b5ff 0%,
    rgba(199, 228, 255, 1) 100%
  ) !important;
}
.el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>